"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSkipper = exports.standardColumns = exports.replaceTemplateValues = exports.formatValue = exports.formatSpecial = exports.formatData = exports.formatCell = exports.defaultSortBy = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _reactRouterDom = require("react-router-dom");
var _TableFilter = _interopRequireDefault(require("./TableFilter"));
var _Select = _interopRequireDefault(require("../form/Select"));
var _Square = _interopRequireDefault(require("../../elements/Square"));
var _TextInput = _interopRequireDefault(require("../form/TextInput"));
var _Icon = _interopRequireDefault(require("../../elements/Icon"));
var _CoreSanitize = require("../../utilities/CoreSanitize");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-no-useless-fragment */

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit'
});
const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
});
const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
});
const monthFormatter = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  year: 'numeric'
});
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
const useSkipper = () => {
  const shouldSkipRef = _react.default.useRef(true);
  const shouldSkip = shouldSkipRef.current;

  // Wrap a function with this to skip a pagination/footer reset temporarily
  const skip = _react.default.useCallback(() => {
    shouldSkipRef.current = false;
  }, []);
  _react.default.useEffect(() => {
    shouldSkipRef.current = true;
  });
  return [shouldSkip, skip];
};

// export const useIntSkipper = () => {
//   const shouldSkipRef = React.useRef(0);
//   const shouldSkip = shouldSkipRef.current

//   React.useEffect(() => {
//     shouldSkipRef.current = true
//   })

//   return [shouldSkip, skip];
// }
exports.useSkipper = useSkipper;
const formatData = (col, value) => {
  if (!value && value !== 0 || col.editable) {
    return '';
  }
  if (col.dataType === 'number') {
    return col.fractionalDigits ? value.toFixed(col.fractionalDigits) : value;
  }
  if (col.dataType === 'percent') {
    return `${col.fractionalDigits ? value.toFixed(col.fractionalDigits) : value}%`;
  }
  if (col.dataType === 'currency') {
    return currencyFormatter.format(value);
  }
  if (col.dataType === 'date') {
    const dateValue = value && typeof value.getMonth !== 'function' ? new Date(value) : value;
    return dateFormatter.format(dateValue);
  }
  if (col.dataType === 'datetime') {
    const dateValue = value && typeof value.getMonth !== 'function' ? new Date(value) : value;
    return dateTimeFormatter.format(dateValue);
  }
  if (col.dataType === 'time') {
    const dateValue = value && typeof value.getMonth !== 'function' ? new Date(value) : value;
    return timeFormatter.format(dateValue);
  }
  if (col.dataType === 'month') {
    const dateValue = value && typeof value.getMonth !== 'function' ? new Date(value) : value;
    return monthFormatter.format(dateValue);
  }
  if (col.dataType === 'html') {
    const htmlFormattedValue = /*#__PURE__*/_react.default.createElement("div", {
      className: "html-content",
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(value, {
          USE_PROFILES: {
            html: true
          }
        })
      }
    });
    return htmlFormattedValue;
  }
  if (!col.dataType && value && typeof value.getMonth === 'function') {
    // If dataType not specified, and the value is a Date, then format it as 'date'
    return dateFormatter.format(value);
  }
  return value;
};
exports.formatData = formatData;
const formatValue = (tableProps, col, value) => [tableProps, col, formatData(col, value)];
exports.formatValue = formatValue;
const replaceTemplateValues = (template, templateData, accessor, formattedValue) => template.replace(/{(.+?)}/g, (match, group1) => group1 === accessor ? formattedValue : templateData[group1] || '');
exports.replaceTemplateValues = replaceTemplateValues;
const formatSpecial = (tableProps, col, value, row, originalValue) => {
  let formattedValue = value;
  let cellValue = '';
  if (col.accessors) {
    col.accessors.forEach((accessor, idx) => {
      const accessorValue = col.accessor === accessor ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedValue) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, row[accessor]);
      cellValue = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cellValue && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cellValue), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, accessorValue), idx + 1 !== col.accessors.length && /*#__PURE__*/_react.default.createElement("br", null));
    });
    formattedValue = cellValue;
  }
  if (col.dataType === 'link' && col.linkUrl) {
    const pathname = replaceTemplateValues(col.linkUrl, row, col.accessor, formattedValue);
    formattedValue = pathname.startsWith('http') ? /*#__PURE__*/_react.default.createElement("a", {
      href: pathname
    }, formattedValue) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: {
        pathname,
        state: {
          rowData: row
        }
      }
    }, formattedValue);
  }
  if (col.template && typeof originalValue !== 'undefined' && originalValue !== null) {
    formattedValue = replaceTemplateValues(col.template, row, col.accessor, formattedValue);
    formattedValue = /*#__PURE__*/_react.default.createElement("div", {
      className: "html-content"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(formattedValue, {
          USE_PROFILES: {
            html: true
          }
        })
      }
    });
  }
  if (col.nullValueTemplate && (typeof originalValue === 'undefined' || originalValue === null)) {
    formattedValue = replaceTemplateValues(col.nullValueTemplate, row, col.accessor, formattedValue);
    formattedValue = /*#__PURE__*/_react.default.createElement("div", {
      className: "html-content",
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(formattedValue, {
          USE_PROFILES: {
            html: true
          }
        })
      }
    });
  }
  if (col.dataType === 'select' && col.options) {
    formattedValue = /*#__PURE__*/_react.default.createElement(_Select.default, {
      control: false,
      color: "link",
      placeholder: "Select an Option",
      options: col.options.map(option => {
        const templatedOption = {
          ...option
        };
        if (templatedOption.value) {
          templatedOption.value = replaceTemplateValues(option.value, row, col.accessor, formattedValue);
        }
        return templatedOption;
      }),
      onChange: selectedValue => {
        if (selectedValue !== null && selectedValue !== void 0 && selectedValue.value && !selectedValue.value.startsWith('http')) {
          tableProps.history.push(selectedValue.value);
        }
        if (selectedValue !== null && selectedValue !== void 0 && selectedValue.value && selectedValue.value.startsWith('http')) {
          window.location.href = (0, _CoreSanitize.sanitizeUrl)(selectedValue.value);
        }
      }
    });
  }
  if (col.dataType === 'square') {
    formattedValue = /*#__PURE__*/_react.default.createElement(_Square.default, {
      size: col.size || 'medium',
      color: col.color
    }, formattedValue);
  }
  if (typeof col.cell === 'function') {
    formattedValue = col.cell(row);
  }
  return formattedValue;
};
exports.formatSpecial = formatSpecial;
const formatCell = (props, col, row, value) => formatSpecial(...formatValue(props, col, value), row, value);
exports.formatCell = formatCell;
const defaultSortBy = (a, b) => {
  // force null and undefined to the bottom
  // eslint-disable-next-line no-param-reassign
  a = a === null || a === undefined ? -Infinity : a;
  // eslint-disable-next-line no-param-reassign
  b = b === null || b === undefined ? -Infinity : b;
  // force any string values to lowercase
  // eslint-disable-next-line no-param-reassign
  a = a === 'string' ? a.toLowerCase() : a;
  // eslint-disable-next-line no-param-reassign
  b = b === 'string' ? b.toLowerCase() : b;
  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
  return 0;
};

// eslint-disable-next-line no-unused-vars
exports.defaultSortBy = defaultSortBy;
const filterColumn = (column, value) => {
  // const table = tableReference.current;
  // table.filterColumn(column, value);
};
const isExpanderColumn = (col, pivotBy) => col.expander || pivotBy && pivotBy.includes(col.accessor);
const standardColumns = (columnsArray, pivotBy, expanderFlare, props) => {
  const stdColumns = [];
  columnsArray.forEach((col, colIndex) => {
    const header = col.Header || col.header;
    const stdColumn = {
      // eslint-disable-next-line react/prop-types
      header: _ref => {
        let {
          column,
          table
        } = _ref;
        if (!col.filter) {
          return /*#__PURE__*/_react.default.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(header, {
                USE_PROFILES: {
                  html: true
                }
              })
            }
          });
        }
        const columnData = [...new Set(table.getFilteredRowModel().rows.map(row => row[col.accessor]))];
        return /*#__PURE__*/_react.default.createElement(_TableFilter.default, {
          columnName: header,
          handleFilterChange: value => filterColumn(column, value),
          items: columnData
        });
      },
      width: col.width,
      id: col.id || (!col.accessor ? col.Header || col.header : undefined),
      accessorKey: col.accessor,
      enableSorting: col.sortable,
      subTotal: col.subTotal,
      pivot: pivotBy && pivotBy.includes(col.accessor),
      align: col.align,
      headerClassName: (0, _classnames.default)({
        [col.headerClassName]: col.headerClassName,
        'is-right': col.align === 'right' || col.dataType === 'number' || col.dataType === 'currency' || col.dataType === 'percent',
        'is-center': col.align === 'center'
      }),
      footerClassName: (0, _classnames.default)({
        [col.footerClassName]: col.footerClassName,
        'is-right': col.align === 'right' || col.dataType === 'number' || col.dataType === 'currency' || col.dataType === 'percent',
        'is-center': col.align === 'center'
      }),
      className: (0, _classnames.default)({
        [col.className]: col.className,
        'has-expander-flare': expanderFlare,
        'is-right': col.align === 'right' || col.dataType === 'number' || col.dataType === 'currency' || col.dataType === 'percent',
        'is-center': col.align === 'center'
      }),
      columns: col.columns ? standardColumns(col.columns) : undefined,
      expander: col.expander,
      // eslint-disable-next-line no-unused-vars
      filterMethod: (filter, row, column) => {
        if (filter !== null && filter !== void 0 && filter.value && (filter === null || filter === void 0 ? void 0 : filter.value.length) > 0) {
          const match = filter.value.indexOf(row[filter.id]) > -1;
          return match;
        }
        return true;
      },
      disableExpander: false,
      cell: _ref2 => {
        let {
          getValue,
          row: {
            index,
            original,
            expander
          },
          column: {
            id
          },
          table
        } = _ref2;
        const removeRowInternal = idx => {
          var _table$options$meta;
          (_table$options$meta = table.options.meta) === null || _table$options$meta === void 0 || _table$options$meta.removeRow(idx);
        };
        const updateDataInternal = (idx, colId, val) => {
          var _table$options$meta2;
          (_table$options$meta2 = table.options.meta) === null || _table$options$meta2 === void 0 || _table$options$meta2.updateData(idx, colId, val);
        };
        const formattedValue = (0, _react.useMemo)(() => formatCell(props, col, original, getValue()), [props, col, getValue(), original]);
        if (col.editable) {
          const initialValue = getValue();
          // We need to keep and update the state of the cell normally
          const [value, setValue] = _react.default.useState(initialValue);

          // When the input is blurred, we'll call our table meta's updateData function
          const onBlur = () => {
            const item = col.dataType === 'number' || col.dataType === 'percent' || col.dataType === 'currency' ? parseInt(value, 10) : value;
            updateDataInternal(index, id, item);
          };
          const onChange = val => {
            setValue(val);
            // updateDataInternal(index, id, val)
          };

          // If the initialValue is changed external, sync it up with our state
          _react.default.useEffect(() => {
            setValue(initialValue);
          }, [initialValue]);
          return /*#__PURE__*/_react.default.createElement(_TextInput.default, {
            field: false,
            name: `row_${index}_col_${id}`,
            tabIndex: index * colIndex + colIndex,
            onChange: val => onChange(val),
            onBlur: onBlur,
            placeholder: col.placeholder,
            type: col.type ?? 'text',
            min: col.min,
            max: col.max,
            value: value
          });
        }
        if (col.showDelete) {
          return /*#__PURE__*/_react.default.createElement("a", {
            onClick: () => removeRowInternal(index)
          }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            name: "delete_outline",
            size: 3
          }));
        }
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !expander && /*#__PURE__*/_react.default.createElement("div", {
          className: "is-hidden-tablet"
        }, /*#__PURE__*/_react.default.createElement("strong", {
          dangerouslySetInnerHTML: {
            __html: _dompurify.default.sanitize(header, {
              USE_PROFILES: {
                html: true
              }
            })
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: isExpanderColumn(col, pivotBy) ? '' : 'has-text-right-touch'
        }, formattedValue));
      },
      aggregatedFn: (0, _react.useMemo)(() => {
        if (col.subTotal === 'avg') {
          return 'mean';
        }
        if (col.subTotal === 'color') {
          return 'min';
        }
        return col.subTotal;
      }, [col]),
      // eslint-disable-next-line no-unused-vars
      aggregatedCell: _ref3 => {
        let {
          row,
          column,
          cell,
          getValue
        } = _ref3;
        const value = getValue();
        return (0, _react.useMemo)(() => {
          let formattedValue = null;
          if (col.subTotal) {
            formattedValue = value;
          }
          if (!col.subTotal && !formattedValue && !col.groupCell) {
            return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
          }
          if (value) {
            formattedValue = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, formattedValue));
          }
          if (col.subTotal && col.dataType === 'number') {
            formattedValue = /*#__PURE__*/_react.default.createElement("strong", null, parseFloat(value ?? 0).toFixed(col.fractionalDigits ? col.fractionalDigits : 0));
          }
          if (col.subTotal && col.dataType === 'percent') {
            formattedValue = /*#__PURE__*/_react.default.createElement("strong", null, parseFloat(value ?? 0).toFixed(col.fractionalDigits ? col.fractionalDigits : 0), '%');
          }
          if (col.subTotal && col.dataType === 'currency') {
            const formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD'
            });
            formattedValue = /*#__PURE__*/_react.default.createElement("strong", null, formatter.format(parseFloat(value ?? 0)));
          }
          if (col.subTotal === 'color' && value) {
            formattedValue = /*#__PURE__*/_react.default.createElement(_Square.default, {
              size: col.size || 'small',
              rawColor: value
            });
          }
          if (typeof col.groupCell === 'function') {
            formattedValue = col.groupCell(row);
          }
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "is-hidden-tablet"
          }, /*#__PURE__*/_react.default.createElement("strong", {
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(header, {
                USE_PROFILES: {
                  html: true
                }
              })
            }
          })), /*#__PURE__*/_react.default.createElement("strong", null, formattedValue));
        }, [value, col]);
      }
    };
    if (col.footer) {
      stdColumn.footerValue = col.footer;
      stdColumn.footer = _ref4 => {
        let {
          table
        } = _ref4;
        if (col.footer && typeof col.footer === 'string') {
          // Don't display header when raw text is specified
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "is-hidden-tablet"
          }), /*#__PURE__*/_react.default.createElement("strong", null, col.footer));
        }
        if (col.footer && col.dataType === 'number') {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "is-hidden-tablet"
          }, /*#__PURE__*/_react.default.createElement("strong", {
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(header, {
                USE_PROFILES: {
                  html: true
                }
              })
            }
          })), /*#__PURE__*/_react.default.createElement("strong", null, table.getCoreRowModel().rows.reduce((total, currentValue) => total + (typeof currentValue.original[col.accessor] === 'number' && currentValue.original[col.accessor] ? currentValue.original[col.accessor] : 0), 0).toFixed(col.fractionalDigits ? col.fractionalDigits : 0)));
        }
        if (col.footer && col.dataType === 'percent') {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "is-hidden-tablet"
          }, /*#__PURE__*/_react.default.createElement("strong", {
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(header, {
                USE_PROFILES: {
                  html: true
                }
              })
            }
          })), /*#__PURE__*/_react.default.createElement("strong", null, table.getCoreRowModel().rows.reduce((total, currentValue) => total + (typeof currentValue.original[col.accessor] === 'number' && currentValue.original[col.accessor] ? currentValue.original[col.accessor] : 0), 0).toFixed(col.fractionalDigits ? col.fractionalDigits : 0), '%'));
        }
        if (col.footer && col.dataType === 'currency') {
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          });
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "is-hidden-tablet"
          }, /*#__PURE__*/_react.default.createElement("strong", {
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(header, {
                USE_PROFILES: {
                  html: true
                }
              })
            }
          })), /*#__PURE__*/_react.default.createElement("strong", null, formatter.format(table.getCoreRowModel().rows.reduce((total, currentValue) => total + (typeof currentValue.original[col.accessor] === 'number' && currentValue.original[col.accessor] ? currentValue.original[col.accessor] : 0), 0))));
        }
        if (col.footer) {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, table.getFilteredRowModel().rows.reduce(total => total + 1, 0)));
        }
        return null;
      };
    }
    stdColumns.push(stdColumn);
  });
  return stdColumns;
};
exports.standardColumns = standardColumns;
//# sourceMappingURL=CoreTableUtils.js.map